import styled from "styled-components";

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
  color: #191c1a;
`;

export const Typography = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #0f0f1e99;
  opacity: 0.6;
  margin: 0;
`;

export const Header = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #191c1a;
`;

export const Subheader = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #0f0f1e99;
`;
